import { useEffect, useState } from "react";
import { FormIscrizioneProvider, useFormIscrizione } from "./FormContext";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Societa from "./tipologie/Societa";
import Persona from "./tipologie/Persona";
import Ditta from "./tipologie/Ditta";
import {
  elencoToponomie,
  getProvince,
  getTipologiaAzienda,
} from "./utils/registerAPI";
import { deepTrimStrings, validateForm } from "./utils/validationFunctions";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/slices/snackbar";
import Credenziali from "./utils/Credenziali";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Iscrizione = () => {
  const { formState, dispatch } = useFormIscrizione();
  const [tipologia, setTipologia] = useState("societa");
  const [province, setProvince] = useState([]);
  const [loadingPage, setLoadingPage] = useState(true);
  const [toponomie, setToponomie] = useState([]);
  const [tipologiaAzienda, setTipologiaAzienda] = useState([]);
  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    datiResponsabile: {},
    datiAzienda: {},
  });
  const dispatchSnackbar = useDispatch();

  // Snackbar helper
  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  console.log(formState);

  const tipologie = [
    { value: "societa", label: "Società" },
    { value: "ditta", label: "Ditta Individuale" },
    { value: "persona", label: "Persona Fisica" },
  ];

  useEffect(() => {
    getTipologiaAzienda().then((response) => {
      setTipologiaAzienda(response.data);
    });
    getProvince().then((response) => {
      setProvince(response.data);
    });
    elencoToponomie()
      .then((response) => setToponomie(response.data))
      .finally(() => setLoadingPage(false));
  }, []);

  const handleSubmit = async () => {
    if (!validateForm(tipologia, formState, setErrors)) {
      handleSnackbar("Compila tutti i campi obbligatori.", "error");
      return;
    }
    const cleanData = deepTrimStrings(formState);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: cleanData,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/register`,
        requestOptions
      );

      const responseData = await response.json();

      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        navigate("/auth/act-control/" + responseData.data.idUID);
      }
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  return (
    <>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: "100%", my: 8 }}>
          <Box m={4} display="flex" justifyContent="center">
            <FormControl size="small" margin="none">
              <InputLabel id="tipologia-label">Tipologia</InputLabel>
              <Select
                labelId="tipologia-label"
                id="tipologia"
                name="tipologia"
                label="Tipologia"
                value={tipologia}
                MenuProps={MenuProps}
                onChange={(e) => {
                  setTipologia(e.target.value);
                  setErrors({
                    datiResponsabile: {},
                    datiAzienda: {},
                  });
                  dispatch({
                    type: "set_tipologia",
                    payload: e.target.value,
                  });
                  dispatch({
                    type: "reset_and_set_section",
                  });
                }}
              >
                {tipologie.map((tipo) => (
                  <MenuItem key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box>
            {tipologia === "societa" ? (
              <Societa
                tipologiaAzienda={tipologiaAzienda}
                province={province}
                toponomie={toponomie}
                errors={errors || {}}
              />
            ) : tipologia === "ditta" ? (
              <Ditta
                province={province}
                toponomie={toponomie}
                errors={errors || {}}
              />
            ) : (
              <Persona
                province={province}
                toponomie={toponomie}
                errors={errors || {}}
              />
            )}
          </Box>
          <Box my={4}>
            <Credenziali errors={errors || {}} />
          </Box>
          <Box display="flex" justifyContent="center">
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Registrati
            </Button>
          </Box>
          <Box display="flex" justifyContent="start">
            <Button component={Link} to="/auth/sign-in" color="primary">
              Vai alla Login
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

const FormIscrizione = () => (
  <FormIscrizioneProvider>
    <Iscrizione />
  </FormIscrizioneProvider>
);

export default FormIscrizione;
